<!-- main container -->
<div *ngIf="currentExperiment">
  <!-- main tabs -->
  <mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
    <!-- tab: inputs -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span #firstTab>Inputs</span>
      </ng-template>
      <!-- second tabs -->
      <mat-tab-group>
        <!-- tab: instructions & instruments -->
        <mat-tab label="Instructions & Instruments">
          <div class="instructions-container">
            <!-- first row -->
            <div class="first-row">
              <div>
                <mat-checkbox
                  [disabled]="isExpReopened() || legendFileName!=='' || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled"
                  [(ngModel)]="provideChannelData">Provide Channel
                  Data</mat-checkbox>
              </div>
              <div class="file-buttons-container">
                <div class="file-button-container">
                  <button mat-raised-button color="primary" (click)="validateLegendFile(legendFileInput)"
                    [disabled]="isExpReopened() || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">
                    <mat-icon>upload</mat-icon>
                    <span class="required">*</span>
                    Import Legend File
                  </button>
                  <ng-container *ngIf="(currentExperiment | icstatusIs : ['Created']) && legendFileName">
                    <button mat-raised-button color="warn" (click)="removeLegendFile()" matTooltip="Remove Legend File"
                      [disabled]="isExpReopened() || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">
                      <mat-icon>delete</mat-icon>
                      Remove Legend File
                    </button>
                  </ng-container>
                </div>
                <div class="files-container">
                  &nbsp;
                  <div class="legend-file-container">
                    <ng-container *ngIf="legendFileName">
                      <mat-icon class="success">
                        check_circle
                      </mat-icon>
                      <span>&nbsp;{{legendFileName}}</span>
                    </ng-container>
                  </div>
                </div>
                <input #legendFileInput type="file" accept=".xlsx" style="display: none;"
                  (change)="onLegendFileUpload($event)" />
                <div class="file-button-container">
                  <button mat-raised-button color="primary" (click)="templateFilesInput.click()"
                    matTooltip="Upload a folder with 1 json file and 2 raw files"
                    [disabled]="isExpReopened() || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">
                    <mat-icon>upload</mat-icon>
                    <span class="required">*</span>
                    Import Template Files
                  </button>
                  <ng-container *ngIf="(currentExperiment | icstatusIs : ['Created']) && templateFileNames.length > 0">
                    <button mat-raised-button color="warn" (click)="removeTemplateFiles()"
                      matTooltip="Remove Template Files"
                      [disabled]="isExpReopened() || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">
                      <mat-icon>delete</mat-icon>
                      Remove Template Files
                    </button>
                  </ng-container>
                </div>
                <div class="template-files-container">
                  <ng-container *ngIf="templateFileNames.length > 0">
                    <div class="template-file-row" *ngFor="let fileName of templateFileNames;">
                      <mat-icon class="success">
                        check_circle
                      </mat-icon>
                      <span>{{fileName}}</span>
                    </div>
                  </ng-container>
                </div>
                <input #templateFilesInput type="file" webkitdirectory multiple style="display: none;"
                  (change)="onTemplateFilesUpload($event)" />
              </div>
              <div class="instruments-container">
                <div class="instrument-groups-container">
                  <b>CC Instrument Groups:</b>
                  <app-group-select [groups]="instrumentGroups"
                    [disabled]="isExpReopened() || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled"
                    [groupIdProp]="'instrumentGroupId'" [groupDisplayProp]="'name'" [groupItemsProp]="'instruments'"
                    [itemIdProp]="'instrumentId'" [itemDisplayProp]="'instrumentSerial'"
                    (groupSelected)="onSelectGroup($event)" (itemSelected)="onSelectItem($event)"
                    [selectedItems]="selectedInstruments">
                  </app-group-select>
                  <b>Type an Instrument Serial Number:</b>
                  <input type="text" [(ngModel)]="customSerialNumber" />
                  <div class="button-container">
                    <button mat-raised-button class="success-button" (click)="onAddInstrument()"
                      [disabled]="isExpReopened() || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">
                      <mat-icon>add</mat-icon>
                      Add
                    </button>
                  </div>
                </div>
                <div class="instrument-selected-container">
                  <b>Instruments selected:</b>
                  <div class="selected-instruments-list">
                    <div *ngFor="let instrument of selectedInstruments" class="instrument-row">
                      <div class="instrument-serial-number">{{ instrument.instrumentSerial }}</div>
                      <div class="instrument-cell">
                        <button class="error" mat-icon-button (click)="removeInstrument(instrument)"
                          [disabled]="isExpReopened() || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">
                          <mat-icon>remove_circle</mat-icon>
                        </button>
                      </div>
                      <mat-icon *ngIf="instrument.hasLUTFile" class="success">
                        check_circle
                      </mat-icon>
                      <mat-icon *ngIf="!instrument.hasLUTFile" class="error">
                        cancel
                      </mat-icon>
                      <div class="instrument-cell" *ngIf="!instrument.hasLUTFile">
                        <button class="sync-device-btn" mat-raised-button color="primary"
                          (click)="syncDevice(instrument)">
                          Upload LUT
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- second row -->
            <div class="second-row">
              <h2>Default settings</h2>
              <span>They can be changed on a case by case basis if needed</span>
              <div class="row">
                <label for="incubation">Incubation</label>
                <mat-icon color="primary"
                  matTooltip="How many seconds to wait after the cassette is inserted before taking the picture. Must be 0 or greater than 9.">information</mat-icon>
                <div class="separator"></div>
                <input appIntegerOnly type="number" name="incubation" id="incubation" [(ngModel)]="incubation" min="10"
                  [disabled]="!(icRoundService.isInLastRound$ | async) ||!(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled" />
                <span>&nbsp;seconds</span>
              </div>
              <div class="error-message" [class.hidden]="incubation >= 10 || incubation === 0">
                <span>Incubation must be greater than 9 or be 0</span>
              </div>
              <div class="row">
                <label for="delay">Delay</label>
                <mat-icon color="primary" matTooltip="How many seconds to wat in between images">information</mat-icon>
                <div class="separator"></div>
                <input appIntegerOnly type="number" name="delay" id="delay" [(ngModel)]="delay" min="1"
                  [disabled]="!(icRoundService.isInLastRound$ | async) || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled" />
                <span>&nbsp;seconds</span>
              </div>
              <div class="error-message" [class.hidden]="delay >= 0">
                <span>Delay must be greater or equal than 0</span>
              </div>
              <div class="row">
                <label for="numberOfImages">Number Of Images</label>
                <div class="separator"></div>
                <input appIntegerOnly type="number" name="numberOfImages" id="numberOfImages"
                  [(ngModel)]="numberOfImages" min="0"
                  [disabled]="!(icRoundService.isInLastRound$ | async) || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">
                <span style="visibility: hidden;">&nbsp;seconds</span>
              </div>
              <div class="error-message" [class.hidden]="numberOfImages >= 0">
                <span>Number of Images must be greater or equal than 0</span>
              </div>
              <div class="separator"></div>
              <div class="actions-container">
                <button mat-raised-button color="primary" (click)="save()"
                  [disabled]="!(icRoundService.isInLastRound$ | async) || isSaveDisabled() || !(currentExperiment | icstatusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">Save</button>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Sequence" [disabled]="legendData.length === 0 || !legendData[0].legendDataId">
          <ic-sequence [experiment]="currentExperiment!" [legendData]="legendData"
            [legendInstructions]="legendInstructions" (onChangeSetReady)="onChangeSetReady($event)"
            (onChangeSequenceSaved)="onChangeSequenceSaved()"
            (onLoadPreviousSequence)="onLoadPreviousSequence()"></ic-sequence>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>
    <!-- tab: in progress -->
    <mat-tab label="In Progress"
      [disabled]="(currentExperiment | icstatusIs : ['Created']) && (icRoundService.isInLastRound$ | async)">
      <div class="in-progress-container">
        <div class="adjust-legend-container">
          <button mat-raised-button color="primary" (click)="adustLegend()">Adjust Legend</button>
          <button mat-raised-button color="primary"
            [disabled]="currentImages <= 0 || !(icRoundService.isInLastRound$ | async) || (currentExperiment | icstatusIs : ['AnalyzingImages','Complete']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled"
            (click)="analyzeImages()">Analyze
            Images</button>
          <ng-container *ngIf="!areAllImagesAnalyzed()">
            <button mat-raised-button (click)="getTestResults(false)" color="primary">
              <mat-icon>refresh</mat-icon>
              Refresh now
            </button>
            <span>Last updated: {{lastUpdateTime | date :'shortTime'}}</span>
          </ng-container>
        </div>
        <ng-container *ngIf="(icRoundService.isInLastRound$ | async)">
          <div class="ready-message" *ngIf="(currentExperiment | icstatusIs : ['Ready'])">
            Experiment is Ready. Sofia2 instruments are each showing cassette instructions. This data is updated every
            60
            seconds
          </div>
          <div class="progress-message"
            *ngIf="(currentExperiment | icstatusIs : ['InProgress']) && !areAllImagesAnalyzed()">
            Experiment is in progress. Sofia2 instruments are each showing cassette instructions. This data is updated
            every 60 seconds
          </div>
          <div class="analyze-images-message"
            *ngIf="(currentExperiment | icstatusIs : ['InProgress']) && areAllImagesAnalyzed()">
            Please click on "Analyze Images" when desired start the image processing in the cloud.
          </div>
        </ng-container>

        <div class="total-container">
          <span>{{currentImages}}/{{totalImages}} Image sets uploaded</span>
          <div class="progressbar-container">
            <div class="progressbar-value" [style.width.%]="currentImages * 100 / totalImages"></div>
          </div>
        </div>
        <div class="instrument-container" *ngFor="let instrument of selectedInstruments; let i = index">
          <div class="replace-instrument-container">
            <div>
              <span>Instrument </span>
              <span *ngIf="i < 9">0</span>
              <span>{{i + 1}}:</span>
              <span>{{getInstrumentLabel(i)}} {{getInstrumentHistory(selectedInstruments[i])}} - Sequence:
                {{instrument.currentImages}}/{{instrument.totalImages}} - {{instrument.currentExtraImages}} Extra
              </span>
            </div>
            <div class="separator"></div>
            <button mat-raised-button color="primary" (click)="replaceInstrument(instrumentOrders[i])"
              [disabled]="!(icRoundService.isInLastRound$ | async) || !(currentExperiment | icstatusIs : ['Ready','InProgress']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled">Replace
              Instrument</button>
          </div>
          <div class="progressbar-container">
            <div class="progressbar-value" [style.width.%]="instrument.currentImages! * 100 / instrument.totalImages!">
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <!-- tab: analyzing images -->
    <mat-tab label="Analyzing Images"
      [disabled]="(currentExperiment | icstatusIs : ['Created','Ready','InProgress']) && (icRoundService.isInLastRound$ | async)"
      (click)="analyzeImages()">
      <div class="analyze-container">
        <div class="reload-container">
          <button mat-raised-button (click)="getImageAnalysis(false)" color="primary"
            [disabled]="((currentExperiment | icstatusIs : ['Complete']) && inProgressImagesProcessed === 0 ) || currentExperiment.isCancelled">
            <mat-icon>refresh</mat-icon>
            Refresh now
          </button>
          <span>Last updated: {{lastUpdateTime | date :'shortTime'}}</span>
        </div>
        <ng-container>
          <div class="processing-container">
            <div class="example-value-container">
              <div class="progressbar-value example-value"></div>
              {{successImagesProcessed}}/{{totalImagesProcessed}} Image sets processed successfully.&nbsp;
            </div>
            <div class="example-value-container">
              <div class="progressbar-value-in-progress example-value"></div>
              {{inProgressImagesProcessed}}/{{totalImagesProcessed}} Image sets in progress.&nbsp;
            </div>
            <div class="example-value-container">
              <div class="progressbar-value-error example-value"></div>
              {{errorImagesProcessed}}/{{totalImagesProcessed}} Image sets processed failed.&nbsp;
            </div>
            <div class="example-value-container">
              <div class="progressbar-value-exluded example-value"></div>
              {{excludedImagesProcessed}}/{{totalImagesProcessed}} Image sets excluded.&nbsp;
            </div>
            <div class="progressbar-container">
              <div class="progressbar-value" [style.width.%]="successImagesProcessed * 100 / totalImagesProcessed">
              </div>
              <div class="progressbar-value-in-progress"
                [style.width.%]="inProgressImagesProcessed * 100 / totalImagesProcessed">
              </div>
              <div class="progressbar-value-error" [style.width.%]="errorImagesProcessed * 100 / totalImagesProcessed">
              </div>
              <div class="progressbar-value-exluded"
                [style.width.%]="excludedImagesProcessed * 100 / totalImagesProcessed">
              </div>
            </div>
          </div>
          <div class="analyzed-message"
            *ngIf="inProgressImagesProcessed > 0 && ((currentExperiment | icstatusIs : ['Complete']) || !(icRoundService.isInLastRound$ | async))">
            Report is ready. Some results are still synchronizing with Elastic, as soon as Data Fusion is updated, the
            link to it will be available.
          </div>
          <div *ngIf="(currentExperiment | icstatusIs : ['Complete']) || !(icRoundService.isInLastRound$ | async)">
            <span>Link to view the results and images in Data Fusion <a
                [href]="inProgressImagesProcessed > 0 ? null : fusionLink"
                [ngClass]="{ 'disabled-link': inProgressImagesProcessed > 0}" target="_blank">Images Analyzed</a></span>
          </div>
          <button *ngIf="(currentExperiment | icstatusIs : ['Complete']) || !(icRoundService.isInLastRound$ | async)"
            class="download-report" mat-raised-button (click)="downloadReport()" color="primary">Dowload Report</button>
        </ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
  <!-- cancel experiment button -->
  <button
    *ngIf="(currentExperiment | icstatusIs : ['Ready','InProgress','AnalyzingImages']) && !currentExperiment.isCancelled"
    mat-raised-button color="warn" (click)="cancelExperiment()" class="cancel-btn">Cancel Experiment</button>
</div>